export default "__VITE_ASSET__IOYvW1jw__"